// extracted by mini-css-extract-plugin
export default {"decor":"Decor_decor__OvREf","inscription":"Decor_inscription__JZFq4","image":"Decor_image__0E7na"};